import React from "react";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { CityProps, StateProps } from "../../../../../domain/models/address.model";
import { GroupProp } from "../../../../components/form-factory/utils/util";
import { CNAESModel } from "../../../../../domain/models/cnae";
import { EconomicActivityModel } from "../../../../../domain/models/economic-activity";
import { EconomicActivitiesData, EconomicActivitiesFields } from "./economic-activities";

export const FieldsCNAES = (
  data: CNAESModel | undefined,
  stateList: StateProps[],
  citiesList: CityProps[],
  economicActivityList: EconomicActivityModel[],
  loadCities: (stateId: number) => void,
  handleEconomicActivitiesData?: (ec: EconomicActivitiesData) => void,
  edit?: boolean,
): GroupProp[] => {

  const handleEconomicActivitiesChange = (ecData: EconomicActivitiesData): void => {
    handleEconomicActivitiesData?.(ecData);
  };

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "CNAE:",
      items: [
        {
          name: "code",
          type: "text",
          label: "Código:",
          validations: "inputRequired",
          initialValue: data?.code,
          disabled: !edit,
          col: {
            xs: 12,
            md: 6,
            lg: 4,
          },
        },
        {
          name: "description",
          type: "text",
          label: "Descrição:",
          validations: "inputRequired",
          initialValue: data?.description,
          disabled: !edit,
          col: {
            xs: 12,
            md: 6,
            lg: 8,
          },
        },
      ],
    },
    {
      groupName: "Activity",
      groupLabel: "Atividade Econômica:",
      items: [
        {
          name: "economicActivities",
          type: "component",
          component: () => (
            <EconomicActivitiesFields
              initialActivities={economicActivityList}
              onChange={handleEconomicActivitiesChange}
              edit={edit}
            />
          )
        }
      ],
    },
  ];
};